<template>
  <section>
    <!--工具条-->
 

    <el-col :span="6" class="toolbar rightsearch">
      <el-input placeholder="搜索" size="small" v-model="query" @change="search">
        <el-button slot="append" icon="search" @click="search"></el-button></el-input>
    </el-col>
    <el-table :data="tableData"
              border
              v-loading="listLoading">
      <el-table-column
        label="商品编号"
        prop="pro_id"
        align="center">
      </el-table-column>
      <el-table-column
        label="商品名称"
        prop="pro_name"
        align="center">
      </el-table-column>
       <el-table-column
        label="首页分类"
        prop="category_name"
        align="center">
      </el-table-column
      <el-table-column
        label="品牌"
        prop="brand_name"
        align="center">
      </el-table-column>
      <el-table-column
        label="分类"
        prop="sec_name"
        align="center">
      </el-table-column>
      
      <el-table-column
        label="商品状态"
        align="center">
        <template scope="scope">
          <div>{{proStatus[scope.row.pro_status]}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="推荐状态"
        prop="recommend"
        align="center"> 
        <template scope="scope">
          <div>{{recommendStatus[scope.row.recommend]}}</div>
        </template>
      </el-table-column>
       <el-table-column
        label="发货方式"
        prop="is_oversea"
        align="center"> 
        <template scope="scope">
          <div>{{isoverseaStatus[scope.row.is_oversea]}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="店铺"
        prop="dianpu_name"
        align="center">
      </el-table-column>
      <el-table-column
        label="备注"
        prop="remark"
        align="center">
      </el-table-column>
      <el-table-column
        label="操作"
        prop="labels"
        align="center">
        <template scope="scope">
          <el-button  type="primary"  size="small"  @click="editSpecHandler(scope.row.pro_id)">修改规格</el-button>
       <!--   <el-button :plain="true" type="info" size="small" @click="showGoodsForm(scope.row)">关联商品</el-button> -->
      
        </template>
      </el-table-column>
    </el-table>


    <!--新增界面-->
    <el-dialog title="新增" v-model="addFormVisible" size="large">
      <el-form :model="addForm" label-width="150px" :rules="formRules" ref="addForm">
        <el-form-item label="商品名称" prop="pro_name">
          <el-input v-model="addForm.pro_name" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="品牌" prop="brand_id">
          <el-select v-model="addForm.brand_id" placeholder="请选择">
            <el-option
              v-for="item in brand"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
         <el-form-item label="首页分类" prop="category_id">
          <el-select v-model="addForm.category_id" placeholder="请选择">
            <el-option
              v-for="item in indexcategory"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级分类" prop="sec_id">
          <el-select v-model="addForm.sec_id" placeholder="请选择">
            <el-option
              v-for="item in secondMenu"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="重量" prop="weight">
          <el-input v-model="addForm.weight" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="适用什么宠物" prop="suit_pet">
          <el-input v-model="addForm.suit_pet" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="商品主图" prop="pro_mainpic">
          <el-upload
            class="avatar-uploader"
            action="https://up.qbox.me"
            :show-file-list='showUploadList'
            :on-success="mainHandleSuccess"
            :on-error="mainHandleError"
            :before-upload="mainBeforeUpload"
            :data='uploadForm'>
            <img v-if="mainPicUrl" :src="mainPicUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="商品图片" prop="pro_pic">
          <el-upload
            action="https://up.qbox.me"
            :on-success="uploadPro"
            :on-error="uploadError"
            :on-remove="removePicPro"
            :before-upload="beforeUpload"
            :data='uploadForm'
            :file-list="fileListPro"
            list-type="picture">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="商品详情图片" prop="prointro_pic">
          <el-upload
            action="https://up.qbox.me"
            :on-success="uploadProintro"
            :on-error="uploadError"
            :on-remove="removePicProintro"
            :before-upload="beforeUpload"
            :data='uploadForm'
            :file-list="fileListProintro"
            list-type="picture">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="商品销量" prop="prosales">
          <el-input v-model="addForm.prosales" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="商品状态" prop="pro_status">
          <el-switch
            v-model="addForm.pro_status"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
        <el-form-item label="推荐状态" prop="recommend">
          <el-select v-model="addForm.recommend" placeholder="请选择">
            <el-option
              v-for="(item, index) in recommendStatus"
              :key="index"
              :label="item"
              :value="index"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="UPC" prop="upc">
          <el-input v-model="addForm.upc" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="备案价" prop="beianjia">
          <el-input v-model="addForm.beianjia" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="原产地" prop="origin_place">
          <el-input v-model="addForm.origin_place" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="仓库" prop="is_oversea">
          <el-select v-model="addForm.is_oversea" placeholder="请选择" style="width: 100%;">
            <el-option
              v-for="(item, index) in overseaArr"
              :key="index"
              :label="item"
              :value="index"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="加入购物车" prop="add_cart">
          <el-switch
            v-model="addForm.add_cart"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
        <el-form-item label="五件批发" prop="five_pifa">
          <el-switch
            v-model="addForm.five_pifa"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
        <el-form-item label="一件代发" prop="one_daifa">
          <el-switch
            v-model="addForm.one_daifa"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
        <el-form-item label="是否包邮" prop="is_baoyou">
          <el-switch
            v-model="addForm.is_baoyou"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
        <el-form-item label="快递模版" prop="moban_id" v-if="addForm.is_baoyou === '0'">
          <el-select v-model="addForm.moban_id" placeholder="请选择" style="width: 100%;">
            <el-option
              v-for="item in mobanArr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属店铺" prop="dianpu_id">
          <el-select v-model="addForm.dianpu_id" placeholder="请选择" style="width: 100%;">
            <el-option
              v-for="item in dianpuList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <div class="spec_border">
          <el-row>
            <el-col :span="12">
              <el-form-item label="商品规格">
                <el-select v-model="prospecForm.spec_name" placeholder="请选择" style="width: 100%;">
                  <el-option
                    v-for="item in prospecArr"
                    :key="item.label"
                    :label="item.label"
                    :value="item.label"
                    size="small">
                  </el-option>
                </el-select>
                <div class="el-form-item__error">必选,可新增不同规格 如 16kg 32kg  一包  两包</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="库存">
                <el-input v-model="prospecForm.inventory" auto-complete="off" size="small" required></el-input>
                <div class="el-form-item__error">必填</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="市场价">
                <el-input v-model="prospecForm.market_price" auto-complete="off" size="small" required></el-input>
                <div class="el-form-item__error">必填</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="宠品价">
                <el-input v-model="prospecForm.cpprice" auto-complete="off" size="small" required></el-input>
                <div class="el-form-item__error">必填</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="是否默认">
                <el-switch
                  v-model="prospecForm.is_default"
                  on-color="#13ce66"
                  off-color="#bfcbd9"
                  on-value='1'
                  off-value='0'>
                </el-switch>
                <div class="el-form-item__error">商品必选一个默认规格</div>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="padding: 5px 0 0 150px;">
              <el-button type="primary" @click="saveSpec" size="small">保存规格</el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-table
                :data="prospecTable">
                <el-table-column
                  prop="spec_name"
                  label="规格">
                </el-table-column>
                <el-table-column
                  prop="market_price"
                  label="市场价">
                </el-table-column>
                <el-table-column
                  prop="cpprice"
                  label="宠品价">
                </el-table-column>
                <el-table-column
                  prop="inventory"
                  label="库存">
                </el-table-column>
                <el-table-column
                  prop="is_default"
                  label="是否默认">
                  <template scope="scope">
                    <div>{{isDefault[scope.row.is_default]}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作">
                  <template scope="scope">
                    <el-button size="small" :plain="true" type="danger" @click="deleteSpec(scope.row.id, scope.row.index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </div>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="addForm.remark" auto-complete="off" size="small" required></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="addSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" v-model="editFormVisible" size="large">
      <el-form :model="editForm" label-width="150px" :rules="formRules" ref="editForm">
        <el-form-item label="商品名称" prop="pro_name">
          <el-input v-model="editForm.pro_name" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="品牌" prop="brand_id">
          <el-select v-model="editForm.brand_id" placeholder="请选择">
            <el-option
              v-for="item in brand"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="首页分类" prop="category_id">
          <el-select v-model="editForm.category_id" placeholder="请选择">
            <el-option
              v-for="item in indexcategory"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级分类" prop="sec_id">
          <el-select v-model="editForm.sec_id" placeholder="请选择">
            <el-option
              v-for="item in secondMenu"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="重量" prop="weight">
          <el-input v-model="editForm.weight" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="适用什么宠物" prop="suit_pet">
          <el-input v-model="editForm.suit_pet" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="商品主图" prop="pro_mainpic">
          <el-upload
            class="avatar-uploader"
            action="https://up.qbox.me"
            :show-file-list='showUploadList'
            :on-success="mainHandleSuccess"
            :on-error="mainHandleError"
            :before-upload="mainBeforeUpload"
            :data='uploadForm'>
            <img v-if="mainPicUrl" :src="mainPicUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="商品图片" prop="pro_pic">
          <el-upload
            action="https://up.qbox.me"
            :on-success="uploadPro"
            :on-error="uploadError"
            :on-remove="removePicPro"
            :before-upload="beforeUpload"
            :data='uploadForm'
            :file-list="fileListPro"
            list-type="picture">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="商品详情图片" prop="prointro_pic">
          <el-upload
            action="https://up.qbox.me"
            :on-success="uploadProintro"
            :on-error="uploadError"
            :on-remove="removePicProintro"
            :before-upload="beforeUpload"
            :data='uploadForm'
            :file-list="fileListProintro"
            list-type="picture">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="商品销量" prop="prosales">
          <el-input v-model="editForm.prosales" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="商品状态" prop="pro_status">
          <el-switch
            v-model="editForm.pro_status"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
        <el-form-item label="推荐状态" prop="recommend">
          <el-select v-model="editForm.recommend" placeholder="请选择">
            <el-option
              v-for="(item, index) in recommendStatus"
              :key="index"
              :label="item"
              :value="index"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="UPC" prop="upc">
          <el-input v-model="editForm.upc" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="备案价" prop="beianjia">
          <el-input v-model="editForm.beianjia" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="原产地" prop="origin_place">
          <el-input v-model="editForm.origin_place" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="仓库" prop="is_oversea">
          <el-select v-model="editForm.is_oversea" placeholder="请选择" style="width: 100%;">
            <el-option
              v-for="(item, index) in overseaArr"
              :key="index"
              :label="item"
              :value="index"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="加入购物车" prop="add_cart">
          <el-switch
            v-model="editForm.add_cart"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
        <el-form-item label="五件批发" prop="five_pifa">
          <el-switch
            v-model="editForm.five_pifa"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
        <el-form-item label="一件代发" prop="one_daifa">
          <el-switch
            v-model="editForm.one_daifa"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
        <el-form-item label="是否包邮" prop="is_baoyou">
          <el-switch
            v-model="editForm.is_baoyou"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
        <el-form-item label="快递模版" prop="moban_id" v-if="editForm.is_baoyou === '0'">
          <el-select v-model="editForm.moban_id" placeholder="请选择" style="width: 100%;">
            <el-option
              v-for="item in mobanArr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
         <el-form-item label="所属店铺" prop="dianpu_id" >
          <el-select v-model="editForm.dianpu_id" placeholder="请选择" style="width: 100%;">
            <el-option
              v-for="item in dianpuList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <div class="spec_border">
          <el-row>
            <el-col :span="12">
              <el-form-item label="商品规格">
                <el-select v-model="prospecForm.spec_name" placeholder="请选择" style="width: 100%;">
                  <el-option
                    v-for="item in prospecArr"
                    :key="item.label"
                    :label="item.label"
                    :value="item.label"
                    size="small">
                  </el-option>
                </el-select>
                <div class="el-form-item__error">必选,可新增不同规格 如 16kg 32kg  一包  两包</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="库存">
                <el-input v-model="prospecForm.inventory" auto-complete="off" size="small" required></el-input>
                <div class="el-form-item__error">必填</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="市场价">
                <el-input v-model="prospecForm.market_price" auto-complete="off" size="small" required></el-input>
                <div class="el-form-item__error">必填</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="宠品价">
                <el-input v-model="prospecForm.cpprice" auto-complete="off" size="small" required></el-input>
                <div class="el-form-item__error">必填</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="是否默认">
                <el-switch
                  v-model="prospecForm.is_default"
                  on-color="#13ce66"
                  off-color="#bfcbd9"
                  on-value='1'
                  off-value='0'>
                </el-switch>
                <div class="el-form-item__error">商品必选一个默认规格</div>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="padding: 5px 0 0 150px;">
              <el-button type="primary" @click="saveSpec" size="small">保存规格</el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-table
                :data="prospecTable">
                <el-table-column
                  prop="spec_name"
                  label="规格">
                </el-table-column>
                <el-table-column
                  prop="market_price"
                  label="市场价">
                </el-table-column>
                <el-table-column
                  prop="cpprice"
                  label="宠品价">
                </el-table-column>
                <el-table-column
                  prop="inventory"
                  label="库存">
                </el-table-column>
                <el-table-column
                  prop="is_default"
                  label="是否默认">
                  <template scope="scope">
                    <div>{{isDefault[scope.row.is_default]}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作">
                  <template scope="scope">
                    <el-button size="small" :plain="true" type="danger" @click="deleteSpec(scope.row.id, scope.row.index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </div>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="editForm.remark" auto-complete="off" size="small" required></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="editSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--选择商品页面-->
    <el-dialog title="选择商品" v-model="selectGoodsVisible">
      <div class="select-goods">
        <el-tree class="goods-tree" highlight-current :data="goodsTypeData" @node-click="handleNodeClick"></el-tree>
        <div class="goods-data">
          <el-checkbox-group v-model="selectGoodsData" v-if="goodsData && goodsData.length > 0">
            <el-checkbox v-for="item of goodsData" :label="item.name+'-'+item.value" :key="item.value" ></el-checkbox>
          </el-checkbox-group>
          <div v-else class="no-goods">暂无数据</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="selectGoodsSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import config from '../../config';
  import {formatPara} from '../../static/js/util.js';
  import {formatDate} from '../../static/js/date.js';
  import {getQiniuToken} from '../../static/js/token.js'
  import basicdata from '../../static/config/basicdata.js';

  export default {
    data() {
      return {
        tableData: [],
        total:0,
        page:1,
        pageSize:100,
        listLoading: false,
        query: '',
        submitLoading: false,
        addFormVisible: false,
        addForm: {
          pro_name: '',
          brand_id: '',
          category_id: '',
          sec_id: '',
          weight: '',
          suit_pet: '',
          pro_mainpic: '',
          pro_pic: '',
          prosales: '',
          prointro_pic: '',
          pro_status: '1',
          related_proids: '',
          remark: '',
          create_time: '',
          update_time: '',
          status: 0,
          recommend: '0',
          upc: '',
          beianjia: '',
          origin_place: '',
          is_oversea: '1',
          admin_id: 0,
          dianpu_id: '',
          add_cart: '1',
          five_pifa: '0',
          one_daifa: '1',
          is_baoyou: '0',
          moban_id: '',
        },
        editFormVisible: false,
        editForm: {},
        formRules: {},
        indexcategory:[],
        brand: [],
        secondMenu: [],
        uploadForm: {
          token: getQiniuToken(),
          key: null
        },
        imageUrl: '',
        imageName: '',
        fileListPro: [],
        fileListProintro: [],
        proPic: [],
        prointroPic: [],
        recommendStatus: basicdata.recommendStatus,
        isoverseaStatus:basicdata.isoverseaStatus,
        showUploadList: false,
        mainPicUrl: '',
        prospecArr: [],
        prospecForm: {
          spec_name: '',
          market_price: '',
          cpprice: '',
          inventory: '',
          is_default: '0'
        },
        isDefault: basicdata.isDefault,
        proStatus: basicdata.proStatus,
        prospecTable: [],
        proid: 0,
        selectGoodsVisible: false,
        goodsTypeData: [],
        goodsData: [],
        selectGoodsData: [],
        overseaArr: basicdata.overseaArr,
        mobanArr: [],
        dianpuList:[],
      }
    },
    methods: {
      //分页方法
      handleSizeChange(size) {
        this.pageSize = size;
        this.search();
      },
      handleCurrentChange(page) {
        this.page = page;
        this.search();
      },
      search() {
        this.getGoodsList(this.query);
      },
      //获取商品列表
      getGoodsList(query) {
        this.listLoading = true;
        this.$axios.get(config.api_url + '/product/kucun', {
          "page": this.page,
          "size": this.pageSize,
          "query": query
        }).then(response => {
          let data = response.data;
          if(data.state) {
            this.total = data.count;
            this.tableData = data.msg;
            this.listLoading = false;
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取数据异常，请联系管理员',
            type: 'error'
          });
          this.listLoading = false;
        })
      },
      //新增数据提交
      addSubmit() {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = formatPara(Object.assign({}, this.addForm));
              para.prosales = parseInt(para.prosales);
              para.pro_pic = this.proPic.toString();
              para.prointro_pic = this.prointroPic.toString();
              para.pro_status = parseInt(para.pro_status);
              para.recommend = parseInt(para.recommend);
              para.pro_mainpic = this.mainPicUrl;
              para.beianjia = parseInt(para.beianjia);
              para.add_cart = parseInt(para.add_cart);
              para.five_pifa = parseInt(para.five_pifa);
              para.one_daifa = parseInt(para.one_daifa);
              para.is_baoyou = parseInt(para.is_baoyou);
              para.moban_id = parseInt(para.moban_id);
              para.is_oversea = parseInt(para.is_oversea);
              //异步请求
              this.$axios.post(config.api_url + '/product',
                para).then(response => {
                if(response.data.state) {
                  //新增商品规格
                  this.addProspec(response.data.msg)
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['addForm'].resetFields();
                  this.mainPicUrl = '';
                  this.proPic = [];
                  this.prointroPic = [];
                  this.fileListPro = [];
                  this.fileListProintro = [];
                  this.prospecTable = [];
                  this.addFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: '提交失败，请联系管理员',
                    type: 'warning'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
      //修改数据弹框
      editHandler(row) {
        this.editFormVisible = true;
        this.editForm = row;
        this.editForm.pro_status = row.pro_status.toString();
        this.editForm.recommend = row.recommend.toString();
        this.editForm.is_oversea = row.is_oversea.toString();
        this.editForm.add_cart = row.add_cart.toString();
        this.editForm.five_pifa = row.five_pifa.toString();
        this.editForm.one_daifa = row.one_daifa.toString();
        this.editForm.is_baoyou = row.is_baoyou.toString();
        //this.editForm.moban_id = row.moban_id.toString();
        this.proPic = row.pro_pic.split(',');
        this.prointroPic = row.prointro_pic.split(',');
        let that = this;
        this.fileListPro = [];
        this.proPic.forEach(function (item, i) {
          that.fileListPro.push({
            name: item.replace(basicdata.picUrl, ''),
            url: item
          })
        });
        this.fileListProintro = [];
        this.prointroPic.forEach(function (item, i) {
          that.fileListProintro.push({
            name: item.replace(basicdata.picUrl, ''),
            url: item
          })
        });
        this.mainPicUrl = row.pro_mainpic;
        //获取商品规格列表
        this.$axios.get(config.api_url + '/product/specification/' + row.pro_id
        ).then(response => {
          this.prospecTable = [];
          let i = 0
          for(const item of response.data.msg) {
            item.index = i;
            this.prospecTable.push(item);
            i++;
          }
        }).catch(error => {
          console.log(error)
        });
      },
      //修改提交
      editSubmit() {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = formatPara(Object.assign({}, this.editForm));
              para.prosales = parseInt(para.prosales);
              para.pro_pic = this.proPic.toString();
              para.prointro_pic = this.prointroPic.toString();
              para.pro_status = parseInt(para.pro_status);
              para.recommend = parseInt(para.recommend);
              para.pro_mainpic = this.mainPicUrl;
              para.beianjia = parseInt(para.beianjia);
              para.add_cart = parseInt(para.add_cart);
              para.five_pifa = parseInt(para.five_pifa);
              para.one_daifa = parseInt(para.one_daifa);
              para.is_baoyou = parseInt(para.is_baoyou);
              // para.moban_id = parseInt(para.moban_id);
              para.is_oversea = parseInt(para.is_oversea);
              //异步请求
              this.$axios.put(config.api_url + '/product',
                para).then(response => {
                if(response.data.state) {
                  //新增商品规格
                  this.addProspec(response.data.msg)
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['editForm'].resetFields();
                  this.mainPicUrl = '';
                  this.proPic = [];
                  this.prointroPic = [];
                  this.fileListPro = [];
                  this.fileListProintro = [];
                  this.prospecTable = [];
                  this.editFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: '提交失败，请联系管理员',
                    type: 'warning'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
      addHandler() {
    
              this.addFormVisible = true;
              this.proPic = [];
              this.fileListPro = [];
              this.prointroPic = [];
              this.fileListProintro = [];
              this.mainPicUrl = '';
              this.prospecTable = [];
            
      },
      //上传图片到七牛
      beforeUpload(file) {
        this.imageName = 'product/' + formatDate(new Date(), 'yyyyMMddhhmmss') + Math.random().toString(36).substr(2);
        let mime = file.name.split('.')[1];
        this.imageName += '.' + mime;
        this.uploadForm.key = this.imageName;
        this.imageUrl = basicdata.picUrl + this.imageName;
      },
      //上传失败
      uploadError(error) {
        console.log(error);
        this.$message({
          message: '图片上传异常，请联系管理员',
          type: 'error'
        });
      },
      //商品图片上传
      uploadPro() {
        this.proPic.push(this.imageUrl);
        this.fileListPro.push({
          name: this.imageName,
          url: this.imageUrl
        })
      },
      //商品详情图片上传
      uploadProintro() {
        this.prointroPic.push(this.imageUrl);
        this.fileListProintro.push({
          name: this.imageName,
          url: this.imageUrl
        })
      },
      //商品图片删除
      removePicPro(file, fileList) {
        this.proPic = this.proPic.filter(x => x !== basicdata.picUrl + file.name);
      },
      //商品详情图片删除
      removePicProintro(file, fileList) {
        this.prointroPic = this.prointroPic.filter(x => x !== basicdata.picUrl + file.name);
      },
      //获取品牌列表
      getBrand() {
        this.$axios.get(config.api_url + '/brand/list'
        ).then(response => {
          let data = response.data;
          if(data.state) {
            for(const item of data.msg) {
              this.brand.push({
                label: item.brand_name,
                value: item.brand_id
              })
            }
          } else {
            this.$message({
              message: '获取品牌失败',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取品牌异常，请联系管理员',
            type: 'error'
          });
        });
      },
             //获取首页分类列表
      getIndexCategory() {
        this.$axios.get(config.api_url + '/indexcategory/list'
        ).then(response => {
          let data = response.data;
          if(data.state) {
            for(const item of data.msg) {
              this.indexcategory.push({
                label: item.category_name,
                value: item.category_id
              })
            }
          } else {
            this.$message({
              message: '获取首页分类失败',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取首页分类异常，请联系管理员',
            type: 'error'
          });
        });
      },
      //获取二级分类列表
      getSecondMenu() {
        this.$axios.get(config.api_url + '/menu/tree'
        ).then(response => {
          let data = response.data;
          if(data && data.length > 0) {
            for(const item of data) {
              for(const item1 of item.sec_menu) {
                this.secondMenu.push({
                  label: item1.sec_name,
                  value: item1.sec_id
                });
              }
            }
          } else {
            this.$message({
              message: '获取分类失败',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取分类异常，请联系管理员',
            type: 'error'
          });
        });
      },
      //上传商品主图片
      mainBeforeUpload (file) {
        let fileName = 'product/' + formatDate(new Date(), 'yyyyMMddhhmmss') + Math.random().toString(36).substr(2);
        let mime = file.name.split('.')[1];
        fileName += '.' + mime;
        this.uploadForm.key = fileName;
      },
      mainHandleSuccess (response, file, fileList) {
        this.mainPicUrl = basicdata.picUrl + this.uploadForm.key;
        this.result = '上传成功'
      },
      mainHandleError (error, response, file) {
        this.result = error.toString()
      },
      //获取规格列表
      getSpec() {
        this.$axios.get(config.api_url + '/specification/list'
        ).then(response => {
          for(const item of response.data.msg) {
            this.prospecArr.push({
              label: item.name,
              value: item.id
            })
          }
        }).catch(error => {
          console.log(error)
        });
      },
      //保存规格，暂存在本地
      saveSpec() {
        let para = this.prospecForm;
        para.is_default = parseInt(para.is_default);
        para.inventory = parseInt(para.inventory);
        para.cpprice = parseInt(para.cpprice);
        para.market_price = parseInt(para.market_price);
        para.index = this.prospecTable.length;
        this.prospecTable.push(para)
        this.prospecForm = {
          spec_name: '',
          market_price: '',
          cpprice: '',
          inventory: '',
          is_default: '0'
        };
      },
      //删除所有规格
      deleteSpec(id, index) {
        if(id > 0) {
          //删除数据库
          this.$axios.delete(config.api_url + '/product/specification/' + id
          ).then(response => {
            if(!response.data.state) {
              this.$message({
                message: '删除规格失败',
                type: 'warning'
              });
            }
          }).catch(error => {
            console.log(error);
            this.$message({
              message: '删除规格异常',
              type: 'error'
            });
          });
        }
        //删除数组
        this.prospecTable.splice(index, 1);
        for(let i = 0; i < this.prospecTable.length; i++) {
          this.prospecTable[i].index = i;
        }
      },
      //新增商品规格
      addProspec(proid) {
        this.$axios.post(config.api_url + '/product/specification/' + proid, this.prospecTable
        ).then(response => {
        }).catch(error => {
          console.log(error)
        })
      },
      //修改规格
      editSpecHandler(proid) {
        this.$router.push("/goods/prospec/" + proid);
      },
      //获取商品分类树
      showGoodsForm(row) {
        this.proid = row.pro_id;
        this.goodsData = [];
        this.selectGoodsData = [];
        this.selectGoodsVisible = true;
        this.$axios.get(config.api_url + '/menu/tree'
        ).then(response => {
          let data = response.data;
          if(data && data.length > 0) {
            let allmenu = [];
            for(const item of data) {
              if(item.sec_menu && item.sec_menu.length > 0) {
                let secMenu = [];
                for(const item1 of item.sec_menu) {
                  secMenu.push({
                    label: item1.sec_name,
                    value: item1.sec_id,
                    isFirst: 0
                  })
                }
                allmenu.push({
                  label: item.fname,
                  value: item.fid,
                  isFirst: 1,
                  children: secMenu
                })
              } else {
                allmenu.push({
                  label: item.fname,
                  value: item.fid,
                  isFirst: 1,
                })
              }
            }
            this.goodsTypeData = allmenu;
          } else {
            this.$message({
              message: '获取树失败',
              type: 'error'
            });
          }
        }).catch(error => {
          this.$message({
            message: '获取树异常，请联系管理员',
            type: 'error'
          });
        });
      },
      //点击树节点，获取商品
      handleNodeClick(data) {
        if(data.isFirst === 0) {
          this.$axios.get(config.api_url + '/product/type/'+data.value
          ).then(response => {
            let data = response.data;
            if(data && data.length > 0) {
              let goodsData = [];
              for(const item of data) {
                goodsData.push({
                  name: item.pro_name,
                  value: item.pro_id
                })
              }
              this.goodsData = goodsData;
              //获取已关联商品
              this.$axios.get(config.api_url + '/product/relateds/'+this.proid
              ).then(response => {
                if(response.data) {
                  let selectData = [];
                  for(const id of response.data.split(',')) {
                    for(const item of goodsData) {
                      if(item.value === parseInt(id)) {
                        selectData.push(item.name + '-' + id);
                      }
                    }
                  }
                  this.selectGoodsData = selectData;
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '获取商品异常，请联系管理员',
                  type: 'error'
                });
              })
            } else {
              this.$message({
                message: '未获取到商品',
                type: 'info'
              });
            }
          }).catch(error => {
            console.log(error);
            this.$message({
              message: '获取商品异常，请联系管理员',
              type: 'error'
            });
          });
        }
      },
      //提交选择商品
      selectGoodsSubmit() {
        if(this.selectGoodsData && this.selectGoodsData.length > 0) {
          let proIds = [];
          for(const item of this.selectGoodsData) {
            proIds.push(item.split('-')[1]);
          }
          this.$axios.post(config.api_url + '/product/related', {
              related_proids: proIds.toString(),
              pro_id: this.proid
            }).then(response => {
            if(response.data.state) {
              this.$message({
                message: '提交成功',
                type: 'success'
              });
              this.selectGoodsVisible = false;
            } else {
              this.$message({
                message: '未获取到商品',
                type: 'info'
              });
            }
          }).catch(error => {
            this.$message({
              message: '获取商品异常，请联系管理员',
              type: 'error'
            });
          });
        }
      },
      getDianpuList() {
        this.$axios.get(config.api_url + '/dianpu/list'
        ).then(response => {
          let data = response.data;
          if(data.state) {
            for(const item of data.msg) {
              this.dianpuList.push({
                label: item.dianpu_name,
                value: item.id
              });
            }
          } else {
            this.$message({
              message: '获取店铺失败',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取店铺异常，请联系管理员',
            type: 'error'
          });
        });
      },
      getKuaidiMoban() {
        this.$axios.get(config.api_url + '/kuaidi/moban'
        ).then(response => {
          if(response.data.state) {
            this.mobanArr = [];
            for(const item of response.data.msg) {
              this.mobanArr.push({
                label: item.name,
                value: item.id
              })
            }
          } else {
            this.$message({
              message: '获取快递模板失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取快递模板异常，请联系管理员',
            type: 'error'
          });
        });
      }
    },
     
    created() {
      this.search();
      this.getBrand();
      this.getIndexCategory();
      this.getSecondMenu();
      this.getSpec();
      this.getKuaidiMoban();
      this.getDianpuList();
    }
  }
</script>

<style scoped>
  .rightsearch{
    float: right;
  }
  .spec_border {
    border: 1px solid #dfe6ec;
    padding: 25px 30px 25px 20px;
    margin-bottom: 20px;
  }
  .select-goods {
    width: 100%;
  }
  .select-goods .goods-tree {
    width: 30%;
    height: 300px;
    overflow-y: scroll;
    float:left;
  }
  .select-goods .goods-data {
    cursor: default;
    background: #fff;
    border: 1px solid #d1dbe5;
    width: 60%;
    margin-left: 40%;
    height: 300px;
    overflow-y: scroll;
  }
  .el-checkbox {
    margin-left: 20px;
    margin-top: 7px;
  }
  .select-goods .no-goods {
    text-align: center;
    color: #5e7382;
    padding-top: 30%;
  }
</style>



// WEBPACK FOOTER //
// kucun.vue?1386566a